module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "TOC-Title",
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Body-Text",
    attrs: {
      "id": "toc1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/CoverImage"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Body-Text",
    attrs: {
      "id": "toc2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Healy_Hauerwas3#toc_marker-1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Body-Text",
    attrs: {
      "id": "toc3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Healy_Hauerwas6#toc_marker-4"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Body-Text",
    attrs: {
      "id": "toc4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Healy_Hauerwas7#toc_marker-5"
    }
  }, [_vm._v("Abbreviations for Books by Stanley Hauerwas")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Body-Text",
    attrs: {
      "id": "toc5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Healy_Hauerwas8#toc_marker-6"
    }
  }, [_vm._v("1. Reading Hauerwas; Reading This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Body-Text",
    attrs: {
      "id": "toc6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Healy_Hauerwas9#toc_marker-7"
    }
  }, [_vm._v("2. The Church, the Center")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Body-Text",
    attrs: {
      "id": "toc7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Healy_Hauerwas10#toc_marker-8"
    }
  }, [_vm._v("3. An Ecclesiocentric Method")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Body-Text",
    attrs: {
      "id": "toc8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Healy_Hauerwas11#toc_marker-9"
    }
  }, [_vm._v("4. The Empirical Church and Christian Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Body-Text",
    attrs: {
      "id": "toc9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Healy_Hauerwas12#toc_marker-10"
    }
  }, [_vm._v("5. Hauerwas’s Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Body-Text",
    attrs: {
      "id": "toc10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Healy_Hauerwas13#toc_marker-11"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Body-Text",
    attrs: {
      "id": "toc11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Healy_Hauerwas14#toc_marker-12"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1c763a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Healy_Hauerwas-5.vue
// module id = 72
// module chunks = 0